import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Title from '../../Title';
import CountryCityBlock from '../../CountryCityBlock';
import DateField from '../../Fields/DateField';

const BirthBlock = ({
  title,
  setFieldValue,
  formValues,
  dateFields,
  minYear,
  country,
  city,
  maxYear,
  className,
  countryFieldsClass,
  dateClassName,
}) => (
  <div className={className}>
    <Title>{title}</Title>
    <DateField dateFields={dateFields} minYear={minYear} maxYear={maxYear} className={dateClassName} />
    <Grid container spacing={3} style={{ width: '100%' }}>
      <CountryCityBlock
        countryField={country}
        cityField={city}
        formValues={formValues}
        setFieldValue={setFieldValue}
        isCreatable
        fieldClass={countryFieldsClass}
      />
    </Grid>
  </div>
);

BirthBlock.propTypes = {
  title: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  formValues: PropTypes.object.isRequired,
  dateFields: PropTypes.object,
  country: PropTypes.object.isRequired,
  city: PropTypes.object.isRequired,
  dateClassName: PropTypes.string,
};

export default BirthBlock;
